export const NewChecklistItemPrefix = 'new_checklist_item'
